import { render, staticRenderFns } from "./piece.vue?vue&type=template&id=40547ac2"
import script from "./piece.vue?vue&type=script&lang=js"
export * from "./piece.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports